import React from 'react';

export const SpeciesTableDeltaColumnWrapper = (props) => {
    const {rowData, children} = props;
    const {modifiedId, nonModifiedId, modifiedValue, nonModifiedValue} = props?.Value ?? {};

    const isModified = (modifiedId ?? nonModifiedId ?? '') !== (nonModifiedId ?? '') || (modifiedValue ?? nonModifiedValue ?? '') !== (nonModifiedValue ?? '');
    const isUnused = rowData?.SpeciesListSpecies?.speciesId == null || rowData?.SpeciesListSpecies?.deleted;

    return <td
        className={
            "sb-table-column " +
            "sb-species-delta-table-column" +
            (isUnused ? " sb-species-delta-table-column-unused" : "") +
            (isModified ? " sb-species-delta-table-column-modified" : "")
        }
    >
        {children}
    </td>;
}


